<template>
    <div class="e3-pointer d-flex flex-row px-3 py-2 text-body">
        <div class="profile-image-container">
            <ProfileImage
                :image-url="message.sender.profile_picture"
                :name="message.sender.fname + ' ' + message.sender.lname"
                size="sm"/>
        </div>
        <div class="d-flex flex-column ml-2 w-100">
            <div class="d-flex flex-row">
                <div class="font-weight-bold">
                    {{ message.sender.fname }} {{ message.sender.lname }}
                </div>
                <div class="ml-auto">
                    <span v-if="message.receiver.seen === null" class="badge badge-primary text-white ml-auto p-2 text-uppercase">
                        {{ $t('New') }}
                    </span>
                </div>
            </div>
            <div class="text-primary text-break">{{ truncate(message.subject, 64) }}</div>
            <div class="text-break">{{ truncate(stripHtmlTags(message.body), 64) }}</div>
            <small class="text-muted">{{ formatDateTime(message.created_at) }}</small>
        </div>
    </div>
</template>

<script>
import {formatDateTime, stripHtmlTags, truncate} from '@/filters';

export default {
    name: 'NotificationListItem',

    props: {
        message: {
            type: Object,
            required: true
        }
    },

    methods: {
        truncate, // TODO: Vue3 remove
        stripHtmlTags, // TODO: Vue3 remove
        formatDateTime // TODO: Vue3 remove
    }
};
</script>


<style scoped>
.profile-image-container {
    padding-top: 4px;
}
</style>
